import React, { useState } from "react";

import { LoadingIcon } from "@packages/ds";
import { useIntl } from "react-intl";

import useDecodedParams from "Hooks/useDecodedParams";
import { selectServicesProcesses } from "Reducers/serviceProcesses/serviceProcesses.selectors";
import { OrderBy, Status } from "Reducers/types";
import { useAppSelector } from "Store/hooks";

import { ListMode } from "./components/ListMode";
import { OptionsDialog } from "./components/OptionsDialog";
import { ListFilters } from "./containers/ListFilters";
import { TableList } from "./containers/TableList";
import { TreeList } from "./containers/TreeList";
import * as S from "./ProcessList.styles";
import { HeadersKeys } from "./utils/headersConfig";

export type ProcessListMode = "table" | "tree";

export const ProcessList = () => {
  const [currentView, setCurrentView] = useState<ProcessListMode>("table");
  const [search, setSearch] = useState("");
  const { formatMessage } = useIntl();
  const { appName } = useDecodedParams<{ appName: string }>();
  const { status } = useAppSelector(selectServicesProcesses);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [orderBy, setOrderBy] = useState<OrderBy<HeadersKeys>>({
    direction: 1,
    field: "cpu_percent"
  });

  return (
    <ListMode fullScreen={isFullScreen} setIsFullScreen={setIsFullScreen}>
      <S.ProcessListRoot>
        <ListFilters
          selected={currentView}
          fullScreen={isFullScreen}
          onChange={setCurrentView}
          onFullScreenChange={setIsFullScreen}
          onSearch={setSearch}
        />

        <S.ProcessListContainer fullScreen={isFullScreen}>
          {status === Status.Loading && (
            <S.LoadingContainer>
              <LoadingIcon />
            </S.LoadingContainer>
          )}

          {status === Status.Rejected && (
            <S.ErrorText weight="semiBold">
              {formatMessage(
                {
                  id: "services.process.options.modal.not_available"
                },
                {
                  appName
                }
              )}
            </S.ErrorText>
          )}

          {status === Status.Fulfilled && currentView === "table" && (
            <TableList
              search={search}
              setOrderBy={setOrderBy}
              orderBy={orderBy}
            />
          )}

          {status === Status.Fulfilled && currentView === "tree" && (
            <TreeList search={search} />
          )}
        </S.ProcessListContainer>

        <OptionsDialog />
      </S.ProcessListRoot>
    </ListMode>
  );
};
